import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IEnseigneState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const enseigneModule: Module<IEnseigneState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default enseigneModule
